import INFTCollections from '../../../models/INFTCollections'
import NFTCollectionsList from '../../../data/NFTCollectionsList'
import { INFTHistoryItem } from '../../../models/INFTHistory'

export default function NFTActivtyFormatDetector(props: INFTHistoryItem) {
  const { tokenContract } = props.historyItem
  const foundedCollection: INFTCollections | undefined = NFTCollectionsList.find(
    (item: INFTCollections) => item.tokenAddress.toLowerCase() === tokenContract.toLocaleLowerCase()
  )

  return foundedCollection
    ? foundedCollection.activityFormat({
        historyItem: props.historyItem,
        chainId: props.chainId,
        collection: foundedCollection
      })
    : NFTCollectionsList[0].activityFormat({
        historyItem: props.historyItem,
        chainId: props.chainId,
        collection: NFTCollectionsList[0]
      })
}
